import { LoginFacebookPayload } from "@ueni/users-api";
import React from "react";
import { FormattedMessage } from "react-intl";
import FacebookIcon from "../../../../../assets/icons/FacebookIcon";
import FbApi from "../../../../../services/FbApi";
import { BaseSocialButton } from "../BaseSocialButton";
import { useFacebookAuthButton } from "./useFacebookAuthButton";

interface Props {
  className?: string;
  onResolve: (data: LoginFacebookPayload) => Promise<void>;
}

export const FacebookAuthButton = ({ className, onResolve }: Props) => {
  const { onClick } = useFacebookAuthButton({ onResolve });

  return (
    <>
      <BaseSocialButton
        icon={<FacebookIcon viewBox="0 0 36 36" />}
        text={<FormattedMessage id="login.facebook" />}
        // @ts-ignore
        onClick={onClick}
        className={className}
      />
      <FbApi />
    </>
  );
};
